// import config from "@/config"
import request from '@/utils/request'
import config from "@/config";
/** 登录api */
export function login(data) {
	return request.post(
		`${config.API_URL}/login`,
	  data
	)
}
